import {
  enableProdMode,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { Drivers } from '@ionic/storage';
import { IonicStorageModule } from '@ionic/storage-angular';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgxSmartBannerModule } from '@netcreaties/ngx-smart-banner';
import * as Sentry from '@sentry/capacitor';
import * as SentryAngular from '@sentry/angular';
import * as CordovaSQLiteDriver from 'localforage-cordovasqlitedriver';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { register } from 'swiper/element/bundle';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import localeNl from '@angular/common/locales/nl';
import localeEn from '@angular/common/locales/en';
import localeDa from '@angular/common/locales/da';
import localeDe from '@angular/common/locales/de';
import localeFr from '@angular/common/locales/fr';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

registerLocaleData(localeNl, 'nl');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeDa, 'da');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeFr, 'fr');
register();

if (environment.production) {
  if (Capacitor.isNativePlatform()) {
    App.getInfo().then((appInfo) => {
      setupSentry(appInfo.id + '@' + appInfo.version);
    });
  } else if (typeof window !== 'undefined') {
    fetch('/assets/config/config-map.json', { cache: 'no-store' })
      .then((res) => res.json())
      .then((config: { release?: string }) =>
        setupSentry(config.release ?? 'pwa@latest')
      )
      .catch(() => setupSentry('pwa@latest'));
  }

  enableProdMode();
}

function setupSentry(release: string) {
  const ignoredErrors = [
    /^Error: Invalid LngLat object: (NaN, NaN)$/,
    /^TypeError: Cannot read properties of null (reading '3')$/,
    /^TypeError: null is not an object (evaluating 'r[3]')$/,
  ];
  Sentry.init(
    {
      dsn: environment.sentryDsn,
      environment: environment.environment,
      release: release,
      ignoreErrors: ignoredErrors,
    },
    SentryAngular.init
  );
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    ...appConfig.providers,
    provideAnimations(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    importProvidersFrom(
      IonicStorageModule.forRoot({
        driverOrder: [
          CordovaSQLiteDriver._driver,
          Drivers.IndexedDB,
          Drivers.LocalStorage,
        ],
      }),
      InlineSVGModule.forRoot(),
      NgxSmartBannerModule
    ),
  ],
}).catch((err) => console.log(err));

defineCustomElements(window);
